/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscription_Rights_Stripe_WarningInputs */

const fr_admin_subscription_rights_stripe_warning = /** @type {(inputs: Admin_Subscription_Rights_Stripe_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce membre a un abonnement en ligne : au prochain événement Stripe (renouvellement, changement de palier…), le palier, l'option et le quota posés à la main seront remplacés par ceux de Stripe.`)
};

/**

* @param {Admin_Subscription_Rights_Stripe_WarningInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_stripe_warning = /** @type {((inputs?: Admin_Subscription_Rights_Stripe_WarningInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_Stripe_WarningInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_stripe_warning(inputs)
});